<template>
    <div>
        <p class="typographies-heading-h3 plugin-summary__content-title">
            {{ $l10n.__('Mes modules supplémentaires') }}
        </p>
        <div class="plugins-list">
            <plugin-item v-for="plugin of pluginsEnabled" :key="plugin.id" :plugin="plugin" />
        </div>
    </div>
</template>
<script>
import PluginItem from 'vcomponents/sellsyaccountmanager/SubscriptionManager/pluginItem.vue';

export default {
    components: {
        PluginItem,
    },
    props: {
        subscriptionItems: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            plugins: [
                {
                    id: 'pack_invoicing',
                    title: this.$l10n.__('Facturation'),
                    description: this.$l10n.__(
                        'Transformez vos devis en factures, activez la signature électronique et faites vous payer en ligne.',
                    ),
                    icon: 'nav-billing',
                },
                {
                    id: 'pack_management',
                    title: this.$l10n.__('Pré-comptabilité'),
                    description: this.$l10n.__(
                        'Saisissez vos achats, calculez vos marges, liez vos banques et exportez les écritures comptables.',
                    ),
                    icon: 'nav-accounting',
                },
                {
                    id: 'pack_stock',
                    title: this.$l10n.__('Stock'),
                    description: this.$l10n.__(
                        'Gérez vos stocks, vos entrepôts, vos commandes et soyez alerté en cas de rupture.',
                    ),
                    icon: 'nav-stock',
                },
                {
                    id: 'pack_cashflow',
                    title: this.$l10n.__('Trésorerie'),
                    description: this.$l10n.__(
                        'Visualisez votre trésorerie en temps réel et réalisez des prévisions.',
                    ),
                    icon: 'nav-cash-flow',
                },
                {
                    id: 'pack_support',
                    title: this.$l10n.__('Support'),
                    description: this.$l10n.__(
                        'Affectez les tickets en un clic à vos collaborateurs, proposez un service personnalisé à vos clients.',
                    ),
                    icon: 'nav-support',
                },
            ],
        };
    },
    computed: {
        pluginsEnabled() {
            return this.plugins.filter((plugin) => plugin.enabled);
        },
    },
    created() {
        for (const plugin of this.plugins) {
            const subscriptionItem = this.subscriptionItems.find((item) =>
                item.item_price_id.includes(plugin.id),
            );
            if (subscriptionItem) {
                plugin.enabled = true;
                if (plugin.id === 'pack_cashflow') {
                    const subscriptionItemId = subscriptionItem.item_price_id.split('_');
                    plugin.plan = subscriptionItemId[2];
                    plugin.subtitle = {
                        starter: 'Standard',
                        pro: 'Evolution',
                        business: 'Elite',
                    };
                }
            }
        }
    },
};
</script>

<style lang="scss" scoped>
p {
    margin: var(--spacing-6) 0 var(--spacing-4);
}

.plugins-list {
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacing-3);
}
</style>
